export const routineIndexDataQualityData = [
    {
      icon : "fa-bezier-curve",
      route: 'open po',
      text : "Open POs"
    },
    {
      icon : "fa-bezier-curve",
      route: 'open invoice',
      text : "Open Invoices"
    },
    {
      icon : "fa-bezier-curve",
      route: '',
      text : "Vendor Created Date missing"
    },
    {
      icon : "fa-bezier-curve",
      route: '',
      text : "Missing user ID in \"created_by\" field"
    },
    {
      icon : "fa-bezier-curve",
      route: '',
      text : "Vendor Changed Date missing"
    },
    {
      icon : "fa-bezier-curve",
      route: '',
      text : "Missing user ID in \"changed_by\" field"
    },
    {
      icon : "fa-bezier-curve",
      route: '',
      text : "Vendors with missing or incomplete address"
    },
    {
      icon : "fa-bezier-curve",
      route: '',
      text : "Vendors with missing telephone number"
    },
    {
      icon : "fa-bezier-curve",
      route: '',
      text : "Vendors with missing, incomplete or invalid bank account"
    },
    {
      icon : "fa-bezier-curve",
      route: '',
      text : "Vendors with \"hold orders\" status"
    },
    {
      icon : "fa-bezier-curve",
      route: '',
      text : "PO's with missing \"Created By\" values"
    },
    {
      icon : "fa-bezier-curve",
      route: '',
      text : "PO's with missing or invalid vendor data"
    },
    {
      icon : "fa-bezier-curve",
      route: '',
      text : "PO's with zero amount line items"
    },
    {
      icon : "fa-bezier-curve",
      route: '',
      text : "PO's with zero total amount"
    },
    {
      icon : "fa-bezier-curve",
      route: '',
      text : "PO's with missing \"Approved By\" values"
    },
    {
      icon : "fa-bezier-curve",
      route: '',
      text : "Goods receipt records with missing or invalid vendor data "
    },
    {
      icon : "fa-bezier-curve",
      route: '',
      text : "Goods receipt records with missing \"Created by\" values"
    },
    {
      icon : "fa-bezier-curve",
      route: '',
      text : "Goods receipt records with missing \"Created date\" values"
    },
    {
      icon : "fa-bezier-curve",
      route: '',
      text : "Goods receipt records with missing or invalid PO"
    },
    {
      icon : "fa-bezier-curve",
      route: '',
      text : "Invoices with zero amount"
    },
    {
      icon : "fa-bezier-curve",
      route: '',
      text : "Invoices with zero total amount"
    },
    {
      icon : "fa-bezier-curve",
      route: '',
      text : "Invoices with missing or invalid vendor data "
    },
    {
      icon : "fa-bezier-curve",
      route: '',
      text : "Invoices with no supplier invoice number"
    },
    {
      icon : "fa-bezier-curve",
      route: '',
      text : "Invoices with missing Created By"
    },
    {
      icon : "fa-bezier-curve",
      route: '',
      text : "Invoices with missing Created Date"
    },
    {
      icon : "fa-bezier-curve",
      route: '',
      text : "Invoices with no PO (blank field)"
    },
    {
      icon : "fa-bezier-curve",
      route: '',
      text : "Invoices with invalid PO (PO not found)"
    },
    {
      icon : "fa-bezier-curve",
      route: '',
      text : "Payments with zero amount"
    },
    {
      icon : "fa-bezier-curve",
      route: '',
      text : "Payments with zero total amount"
    },
    {
      icon : "fa-bezier-curve",
      route: '',
      text : "Payments with missing or invalid vendor data"
    },
    {
      icon : "fa-bezier-curve",
      route: '',
      text : "Payments with missing invoice"
    },
    {
      icon : "fa-bezier-curve",
      route: '',
      text : "Payments with missing Created By"
    },
    {
      icon : "fa-bezier-curve",
      route: '',
      text : "Payments with missing Created Date"
    },
    {
      icon : "fa-bezier-curve",  
      route: '',
      text : "Negative transactions"
    }
]

export const routineIndexSegDutyData = [
	{
		icon : "fa-users",
		route: '',
		text : "Segregation of duties, by value and volume (Created/Changed/Approved) (PO)"
	},
	{
		icon : "fa-users",
		route: '',
		text : "Segregation of duties, by value and volume (Created/Changed/Approved) (GR)"
	},
	{
		icon : "fa-users",
		route: '',
		text : "Segregation of duties, by value and volume (Created/Changed/Approved) (Invoice)"
	},
	{
		icon : "fa-users",
		route: '',
		text : "Segregation of duties, by value and volume (Created/Changed/Approved) (Payments)"
	},
	{
		icon : "fa-users",
		route: '',
		text : "Same creator for PO linked to Invoice linked to Payments / Same creator for Invoice linked to Payments (for invoices without POs)"
	}	
]
export const routineIndexVendorScoreData = [
	{
		icon : "fa-chalkboard-teacher",
		route: '',
		text : "Vendor Anomaly Score"
	},
	{
		icon : "fa-chalkboard-teacher",
		route: 'vendor cluster analysis',
		text : "Vendor cluster analysis"
	}
]
export const routineIndexUnusualTransacData = [
	{
		icon : "fa-exclamation-triangle",
		route: '',
		text : "Exact PO Number, Different Created Date"
	},
	{
		icon : "fa-exclamation-triangle",
		route: '',
		text : "Exact vendor ID, Gross Amount, Created Date, Different PO Number"
	},
	{
		icon : "fa-exclamation-triangle",
		route: '',
		text : "Exact vendor ID, Gross Amount, Created Date, Cost Center, Different PO Number"
	},
	{
		icon : "fa-exclamation-triangle",
		route: '',
		text : "Exact Vendor ID, Invoice Amount, Created Date, Cost Center, Different Invoice Number"
	},
	{
		icon : "fa-exclamation-triangle",
		route: '',
		text : "Exact Created By, Vendor ID, Invoice Amount, Created Date, Different Invoice Number"
	},
	{
		icon : "fa-exclamation-triangle",
		route: '',
		text : "Exact Created By, Vendor ID, Invoice Amount, Created Date, Cost centre, Different Invoice Number"
	},
	{
		icon : "fa-exclamation-triangle",
		route: '',
		text : "Exact supplier invoice number, different Invoice Number"
	},
	{
		icon : "fa-exclamation-triangle",
		route: '',
		text : "Exact vendor, Invoice Amount, Supplier Invoice Number"
	},
	{
		icon : "fa-exclamation-triangle",
		route: '',
		text : "Exact Created By, Vendor ID, Invoice Amount, Created Date, Supplier Invoice Number"
	},
	{
		icon : "fa-exclamation-triangle",
		route: '',
		text : "Exact GR Number, Different Created Date"
	},
	{
		icon : "fa-exclamation-triangle",
		route: '',
		text : "Exact Vendor ID, Quantity, Received date, Different GR"
	},
	{
		icon : "fa-exclamation-triangle",
		route: '',
		text : "Exact Vendor ID, Quantity, Received Amount , Received date, Different GR"
	},
	{
		icon : "fa-exclamation-triangle",
		route: '',
		text : "Exact Vendor ID, Payment Amount, Payment Date"
	},
	{
		icon : "fa-exclamation-triangle",
		route: '',
		text : "Exact vendor ID, Different Bank accounts (change in bank accounts, transaction level)"
	},
	{
		icon : "fa-exclamation-triangle",
		route: '',
		text : "Number of entities/addresses/bank accounts/phone numbers for each vendor"
	},
	{
		icon : "fa-exclamation-triangle",
		route: '',
		text:  "Stratification (PO)"
	},
	{
		icon : "fa-exclamation-triangle",
		route: '',
		text:  "Stratification (Invoices)"
	},
	{
		icon : "fa-exclamation-triangle",
		route: '',
		text:  "Stratification (Payments)"
	},
	{
		icon : "fa-exclamation-triangle",
		route: '',
		text : "Rounded Amount Stratification (PO)"
	},
	{
		icon : "fa-exclamation-triangle",
		route: '',
		text : "Rounded Amount Stratification (Invoices)"
	},
	{
		icon : "fa-exclamation-triangle",
		route: '',
		text : "Rounded Amount Stratification (Payments)"
	},
	{
		icon : "fa-exclamation-triangle",
		route: '',
		text : "Benford analysis (PO)"
	},
	{
		icon : "fa-exclamation-triangle",
		route: '',
		text : "Benford analysis (Invoices)"
	},
	{
		icon : "fa-exclamation-triangle",
		route: '',
		text : "Benford analysis (Payments)"
	},
	{
		icon : "fa-exclamation-triangle",
		route: '',
		text : "PO-Vendor Scatterplot"
	},
	{
		icon : "fa-exclamation-triangle",
		route: '',
		text : "Invoice-Vendor Scatterplot"
	},
	{
		icon : "fa-exclamation-triangle",
		route: '',
		text : "Split purchases slightly below approval limits"
	},
	{
		icon : "fa-exclamation-triangle",
		route: 'gr amount larger than po amount',
		text : "Goods Receipt amount > Purchase Order amount"
	},
	{
		icon : "fa-exclamation-triangle",
		route: 'invoice amount larger than gr amount',
		text : "Invoice amount > Goods Receipt amount"
	},
	{
		icon : "fa-exclamation-triangle",
		route: 'invoice amount larger than po amount',
		text : "Invoice amount > PO amount"
	},
	{
		icon : "fa-exclamation-triangle",
		route: 'payment amount larger than invoice amount',
		text : "Payment amount > Invoice amount"
	},
	{
		icon : "fa-exclamation-triangle",
		route: '',
		text : "Transactions relating to one-time vendors"
	},
	{
		icon : "fa-exclamation-triangle",
		route: '',
		text : "Payments made to a different bank account than that stored in the Vendor Master"
	},
	{
		icon : "fa-exclamation-triangle",
		route: '',
		text : "Payments made to a bank account found in the Employee Master"
	},
	{
		icon : "fa-exclamation-triangle",
		route: '',
		text : "Purchase Order Vendor is not the same as the Goods Receipt Vendor"
	},
	{
		icon : "fa-exclamation-triangle",
		route: '',
		text : "Purchase Order Vendor is not the same as the Invoice Vendor"
	},
	{
		icon : "fa-exclamation-triangle",
		route: '',
		text : "Invoice Vendor is not the same as the Payment Vendor"
	}

]
export const routineIndexTimingData = [
	{
		icon : "fa-calendar-times",
		route: '',
		text : "Vendor master records created on NW&H"
	},
	{
		icon : "fa-calendar-times",
		route: '',
		text : "Vendor master records changed on NW&H"
	},
	{
		icon : "fa-calendar-times",
		route: '',
		text : "POs created on NW&H"
	},
	{
		icon : "fa-calendar-times",
		route: '',
		text : "POs changed on NW&H"
	},
	{
		icon : "fa-calendar-times",
		route: '',
		text : "GRs created on NW&H"
	},
	{
		icon : "fa-calendar-times",
		route: '',
		text : "GRs changed on NW&H"
	},
	{
		icon : "fa-calendar-times",
		route: '',
		text : "Invoices created on NW&H"
	},
	{
		icon : "fa-calendar-times",
		route: '',
		text : "Invoices changed on NW&H"
	},
	{
		icon : "fa-calendar-times",
		route: '',
		text : "Payments created on NW&H"
	},
	{
		icon : "fa-calendar-times",
		route: '',
		text : "Payments changed on NW&H"
	}
]
export const routineIndexUnusualRecordData = [
	{	
		icon : "fa-clipboard",
		route: 'vendor same gst',
		text : "Vendors who share the same Singapore GST Registration Number"
	},
	{	
		icon : "fa-clipboard",
		route: 'vendor same address',
		text : "Vendors who share the same Singapore Address"
	},	
	{	
		icon : "fa-clipboard",
		route: '',
		text : "Employee address found in vendor master"
	},
	{	
		icon : "fa-clipboard",
		route: '',
		text : "Employee bank account found in vendor master"
	},
	{	
		icon : "fa-clipboard",
		route: '',
		text : "Employee holding position in vendor"
	},
	{	
		icon : "fa-clipboard",
		route: '',
		text : "Second-degree conflict of interest - employees holding positions in external companies"
	}
]




// WEBPACK FOOTER //
// ./src/components/Routines/RoutineIndexData.js